import notify, { INotify } from '~/utils/notify'
import { CommentDataProps } from '~/features/Dispatch/stores/DispatchCommentState'
import { LatLng, type marker } from 'leaflet'
import { State } from '@hookstate/core'
import { Id } from 'react-toastify'
import dayjs from 'dayjs'
import { elapsedTime } from '~/utils/dateTime'
interface dispatchSocketProps {
  readonly verifyPermission?: any
  readonly message: any
  readonly translate?: any
  readonly dispatch?: any
  readonly updateStatusRelated?: any
  readonly updateRowsByDispatchId?: any
  readonly updateListAllVehicles?: any
  readonly updateListAllNoPaginationVehicles?: any
  readonly addDispatchComment?: any
  readonly rowsOptNP?: any
  readonly syncDispatchFromId?: any
  readonly socketUpdateLocation?: any
  readonly createMarker?: any
  readonly updateMarker?: any
  readonly addOccurrenceComment?: any
  readonly occurrenceObject?: any
  readonly getMarker?: any
  readonly syncOccurrenceEditAttendent?: any
  readonly windowManager?: any
  readonly user?: any
  readonly openModalResultMultipleCloseDispatches?: any
  readonly socketUpdateCallsDispatch?: any
  readonly socketUpdateCallsOccurrence?: any
  readonly updateDispatchRowsTable?: any
  readonly socketUpdateStatusDispatchRelatedOccurrence?: any
  readonly reloadListOccurrenceDispatches?: any
  readonly socketUpdateListDispatchRelatedOccurrence?: any
  readonly updateListDispatch?: any
  readonly updateStatusOccurrenceDispatchesRelated?: any
  readonly dispatchesOccurrence?: any
  readonly updateListOccurrenceDispatches?: any
  readonly editedComment?: any
  readonly mountUrlRequest?: any
  readonly addDispatchLineTable?: any
  readonly updateOccurrenceRowsTable?: any
  readonly updateDeviceRowsTable?: any
  readonly updateCloseMultipleDispatchRowsTable?: any
  readonly updateDeviceTypeAndSubtypeRowsTable?: any
  readonly dispatchRelated?: any
  readonly actualNotification: () => State<number | null>;
  readonly updateDispatchesRelated?: (any) => void
  readonly updateStatusDeviceRowsTable?: any
  readonly updateCurrentDispatchDeviceTable?: any
  readonly markersState?: any
  readonly forceViewMap?: any
  readonly deleteMarker?: any
  readonly handleClearUniqueNotification?: any
  readonly currentIdNotification?: any
}

// eslint-disable-next-line max-lines-per-function
export default function dispatchSocket({
  verifyPermission,
  message,
  translate,
  dispatch,
  updateStatusRelated,
  updateRowsByDispatchId,
  updateListAllVehicles,
  updateListAllNoPaginationVehicles,
  addDispatchComment,
  rowsOptNP,
  syncDispatchFromId,
  socketUpdateLocation,
  createMarker,
  updateMarker,
  addOccurrenceComment,
  occurrenceObject,
  getMarker,
  syncOccurrenceEditAttendent,
  windowManager,
  user,
  openModalResultMultipleCloseDispatches,
  socketUpdateCallsDispatch,
  socketUpdateCallsOccurrence,
  socketUpdateStatusDispatchRelatedOccurrence,
  reloadListOccurrenceDispatches,
  socketUpdateListDispatchRelatedOccurrence,
  updateListDispatch,
  updateStatusOccurrenceDispatchesRelated,
  dispatchesOccurrence,
  updateListOccurrenceDispatches,
  editedComment,
  mountUrlRequest,
  updateDispatchRowsTable,
  addDispatchLineTable,
  updateOccurrenceRowsTable,
  updateDeviceRowsTable,
  updateCloseMultipleDispatchRowsTable,
  updateDeviceTypeAndSubtypeRowsTable,
  dispatchRelated,
  updateDispatchesRelated,
  updateStatusDeviceRowsTable,
  updateCurrentDispatchDeviceTable,
  markersState,
  forceViewMap,
  deleteMarker,
  handleClearUniqueNotification,
  currentIdNotification,
  actualNotification,
}: dispatchSocketProps) {
  console.info(`Dispatch socket received: ${message.event_type}`)
  const {
    id: dispatchStateId,
    status,
    occurrence: dispatchOcurrence,
  } = dispatch()


  if (message.event_type === 'NEW_DISPATCH_CREATED') {
    try {
      socketUpdateListDispatchRelatedOccurrence({
        agency: message.content.agency,
        code: message.content.code,
        dispatchGroup: message.content.dispatch_group,
        id: message.content.id,
        status: message.content.status,
        occurrenceId: message.content.occurrence.id,
      })
      updateListOccurrenceDispatches({ dispatchesOccurrence })
    } catch (error) {
      console.error(
        `Erro atualizando lista de dispachos da ocorrência ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }
  }

  if (message.event_type === 'DISPATCH_STATUS_CHANGED') {
    try {
      updateStatusRelated({
        dispatchId: message.content.dispatch,
        status: message.content.status,
      })
    } catch (error) {
      console.error(
        `Erro atualizando socket de veículo contendo a seguinte mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }
    try {
      socketUpdateStatusDispatchRelatedOccurrence({
        dispatchId: message.content.dispatch,
        status: message.content.status,
        occurrenceId: message.content.occurrence_id,
      })

    } catch (error) {
      console.error(
        `Erro atualizando socket de veículo contendo a seguinte mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      updateStatusDeviceRowsTable({
        currentStatus: message.content.status,
        dispatch: message.content.dispatch,
      })

    } catch (error) {
      console.error(
        `Erro atualizando socket de veículo contendo a seguinte mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      updateCurrentDispatchDeviceTable({
        dispatchId: message.content.dispatch,
        currentDispatchStatus: message.content.status.id,
      })
    } catch (error) {
      console.error(
        `Erro atualizando socket de veículo contendo a seguinte mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      updateStatusOccurrenceDispatchesRelated({ dispatchesOccurrence })
    } catch (error) {
      console.error(
        `Erro atualizando socket de veículo contendo a seguinte mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      updateListAllVehicles()
    } catch (error) {
      console.error(
        `Erro atualizando a lista de veículos com a mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      updateListAllNoPaginationVehicles()
    } catch (error) {
      console.error(
        `Erro atualizando a lista de veículos com a mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      const currentMarker = getMarker({
        markerType: 'dispatch',
        markerIdentifier: message.content.dispatch,
      })

      if (currentMarker) {
        updateMarker({
          markerType: 'dispatch',
          markerIdentifier: message.content.dispatch,
          attribute: 'status',
          value: message.content.status.id,
        })
      }

      if (message.content.status.id >= 1 && message.content.status.id < 8) {
        updateMarker({
          markerType: 'vehiclePassage',
          markerIdentifier: message.content.dispatch,
          attribute: 'status',
          value: message.content.status.id,
        })
      } else {
        deleteMarker({
          markerType: 'vehiclePassage',
          markerIdentifier: message.content.dispatch,
        })
      }

    } catch (error) {
      console.error(
        `Erro atualizando os pontos do mapa com a mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      updateRowsByDispatchId({
        dispatchId: message.content.dispatch,
        status: message.content.status,
      })
    } catch (error) {
      console.error(
        `Erro atualizando as linhas da tabela com a mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    try {
      updateDispatchRowsTable({
        dispatchId: message.content.dispatch,
        status: message.content.status,
        elapsedTime: message.content.status_updated_at,
      })
    } catch (error) {
      console.error(error)
    }

    rowsOptNP.rowsOpt.updateRowsByDispatchId({
      dispatchId: message.content.dispatch,
      status: message.content.status,
    })

    if (dispatchStateId.get() == message.content.dispatch)
      status.set(message.content.status)
  }

  if (message.event_type === 'DISPATCH_CREATED') {
    const { occurrence, id, code, status, type, subtype, dispatched_at: dispatchedAt } = message.content
    const { latitude, longitude, location } = occurrence

    // try {
    // Criar Aqui
    addDispatchLineTable({
      id: message.content.id,
      occurrence_id: message.content.occurrence.id,
      code: message.content.code,
      status: message.content.status.acronym,
      statusId: message.content.status.id,
      dispatch_group: message.content.dispatch_group.name,
      type: `[${message.content.type.code}] ${message.content.type.name}`,
      subtype: message.content.subtype ? message.content.subtype?.name : '',
      location: message.content.occurrence.location ? message.content.occurrence.location : '',
      city: message.content.occurrence.city.name,
      district: message.content.occurrence.district ? message.content.occurrence.district.name : '',
      notes: "-",
      priority: message.content.priority,
      elapsed_time: message.content.status_updated_at,
      status_updated_at: message.content.status_updated_at,
      highlight: 0,
      dispatched_at: message.content.dispatched_at
    })

    if (dispatchOcurrence?.id?.get() === message.content.occurrence.id && updateDispatchesRelated) {
      updateDispatchesRelated({
        id: message.content.id,
        code: message.content.code,
        status: message.content.status
      })
    }
    // } catch (error) {
    //   console.error(`Erro na criação de um novo despacho tela de suporte com mensagem ${JSON.stringify(message)} - ${JSON.stringify(error)}`);

    // };

    try {
      rowsOptNP.rowsOpt.updateRowsByDispatchId({
        dispatchId: id,
        status: status,
      })
      updateRowsByDispatchId({
        dispatchId: id,
        status: status,
      })

      if (latitude && longitude) {
        const mapMessage = {
          id,
          position: new LatLng(latitude, longitude),
          location: location ?? '',
          code: code,
          status: status.id,
          typeName: type.name,
          subtypeName: subtype?.name ? subtype?.name : null,
          dispatchedAt: dispatchedAt
        }
        createMarker({
          markerType: 'dispatch',
          markerIdentifier: id,
          ...mapMessage,
        })
      }
    } catch (error) {
      console.error(
        `Erro ao atualizar a criação de um novo despacho com mensagem ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }

    if (message.content.emergency) {
      if (verifyPermission(['dispatch_index'])) {
        notify({
          idMessage: message.content.id,
          message: `${translate('New Dispatch with Emergency Created!')} ID-${message.content.code
            } `,
          type: 'warning',
          priority: 3,
          clickableMessage: {
            id: message.content.id,
            urlRedirection: '/dispatch',
            action: () => syncDispatchFromId(message.content.id),
            hideButton: true,
          },
          actualNotification: actualNotification,
        })
      }
    } else {
      if (verifyPermission(['dispatch_index'])) {
        notify({
          idMessage: message.content.id,
          message: `${translate('New Dispatch Created!')} ${message.content.code
            }`,
          type: 'info',
          clickableMessage: {
            id: message.content.id,
            urlRedirection: '/dispatch',
            // action: syncDispatchFromId,
            action: () => syncDispatchFromId(message.content.id),
            hideButton: verifyPermission(['dispatch_index']) ? false : true,
          },
          autoCloseDuration: false,
          actualNotification: actualNotification
        })
      }
    }
  }

  if (message.event_type === 'DISPATCH_ADDRESS_CHANGED') {
    try {
      const {
        dispatch_id: dispatchId,
        occurrence_id: occurrenceId,
        geo: {
          location: location,
          latitude: latitude,
          longitude: longitude,
          city: city,
          district: district,
          address_reference: addressReference,
        },
      } = message.content
      socketUpdateLocation({
        dispatchId: dispatchId,
        geolocation: {
          location,
          latitude,
          longitude,
          cityId: city.id,
          districtId: district ? district.id : null,
          addressReference,
        },
      })

      notify({
        idMessage: message.content.dispatch_id,
        message: `Endereço alterado no despacho - [${message.content.code}]`,
        type: 'info',
        clickableMessage: {
          id: message.content.dispatch_id,
          urlRedirection: '/dispatch',
          // action: syncDispatchFromId,
          action: () => syncDispatchFromId(message.content.dispatch_id),
          hideButton: verifyPermission(['dispatch_index']) ? false : true,
        },
        actualNotification: actualNotification
      })
      updateDispatchRowsTable({
        dispatchId: dispatchId,
        city: city.name,
        district: district ? district.name : '',
        location: location,
      })
    } catch (error) {
      console.error(
        `Erro ao alterar o endereco do despacho ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }
  }
  if (message.event_type === 'OCCURRENCE_COMMENT_CREATED') {
    const openOccurrence = (id) => {
      syncOccurrenceEditAttendent(id)
      windowManager().occurrence.open.set(true)
    }
    try {
      const {
        id: commentId,
        user: senderUser,
        comment,
        media_path: mediaPath,
        created_at: createdAt,
        occurrence_id: occurrenceId,
        closing_comment: closingComment,
        device,
        station,
        from_device_removed: fromDeviceRemoved,
      } = message.content

      if (
        occurrenceId == occurrenceObject().id.get() ||
        occurrenceId == dispatchOcurrence.id.get()
      ) {
        const commentDataObj: CommentDataProps = {
          id: commentId,
          comment: comment,
          mediaPath,
          createdAt,
          occurrenceId: occurrenceId,
          dispatchId: occurrenceId,
          user: senderUser,
          deletedAt: null,
          updatedAt: null,
          closingComment: closingComment,
          device: device,
          station: station,
          fromDeviceRemoved
        }
        occurrenceId == occurrenceObject().id.get() &&
          addOccurrenceComment(commentDataObj)
        occurrenceId == dispatchOcurrence.id.get() &&
          addDispatchComment(commentDataObj)
      }

      if (
        'dispatch_receiver' in message.content &&
        verifyPermission(['dispatch_index'])
      ) {

        if (
          message.content.dispatch_id != message.content.dispatch_receiver.id
        ) {
          notify({
            idMessage: message.content.dispatch_receiver.id,
            message: `${translate('New comment created in dispatch:')} ${message.content.dispatch_receiver.code
              }`,
            type: 'info',
            clickableMessage: {
              id: message.content.dispatch_id,
              action: () => {
                syncDispatchFromId(message.content.dispatch_receiver.id)
              },
              urlRedirection: '/dispatch',
              hideButton: false,
            },
            actualNotification: actualNotification
          })
        }
      }
      if (verifyPermission(['entry_index'])) {
        notify({
          idMessage: message.content.occurrence_id,
          message: `${translate('New comment created in occurrence:')} OC: ${message.content.occurrence_id
            }`,
          type: 'info',
          clickableMessage: {
            id: message.content.occurrence_id,
            action: () => openOccurrence(message.content.occurrence_id),
            hideButton: false,
            urlRedirection: '/entry',
          },
          actualNotification: actualNotification

        })
      }
    } catch (error) {
      console.error(
        `Erro ao criar um comentário em um despacho 02:  ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }
  }

  if (message.event_type === 'DISPATCH_TRANSFER') {
    try {
      const {
        dispatch_id: dispatchId,
        new_group: { acronym: newAcronym, id: newId, name: newName },
        old_group: { acronym: oldAcronym, id: oldId, name: oldName },
        event_type: eventType,
      } = message.content

      if (dispatchId) {
        rowsOptNP.rowsOpt.updateRowsByDispatchId({
          dispatchId: dispatchId,
        })
      }

      updateDispatchRowsTable({
        dispatchId: dispatchId,
        dispatchGroup: newName,
      })
    } catch (error) {
      console.error(
        `Erro ao transferir despacho:  ${JSON.stringify(
          message
        )} - ${JSON.stringify(error)}`
      )
    }
  }

  if (message.event_type === 'OCCURRENCE_RECALL') {
    try {
      const {
        calls,
        occurrence_id: occurrenceId,
        dispatch_id: dispatchId,
      } = message.content

      updateOccurrenceRowsTable({
        occurrenceId: occurrenceId,
        recallWasViewed: false,
      })
      socketUpdateCallsDispatch({ callsNumber: calls, dispatchId: dispatchId })
      socketUpdateCallsOccurrence({
        callsNumber: calls,
        occurrenceId: occurrenceId,
      })
    } catch (error) {
      console.error(`${JSON.stringify(message)} - ${JSON.stringify(error)}`)
    }

    if (verifyPermission(['dispatch_index'])) {
      notify({
        idMessage: message.content.dispatch_id,
        message: `${translate('Recall created!')} [${message.content.code}]`,
        type: 'info',
        clickableMessage: {
          id: message.content.dispatch_id,
          action: () => syncDispatchFromId(message.content.dispatch_id),
          urlRedirection: '/dispatch',
          hideButton: false,
        },
        actualNotification: actualNotification
      })
    }

  }

  if (message.event_type === 'DISPATCH_MULTIPLE_CLOSED') {
    const verifyDispatch = message.content.dispatches.length
    if (verifyDispatch) {
      updateCloseMultipleDispatchRowsTable({ dispatches: message.content.dispatches })
      if (message.content.user_id != user) {
        notify({
          idMessage: message.content.user_id,
          message: `${translate(
            'Closed batch dispatch'
          )} [${message.content.dispatches.map(
            (element) => element.dispatch
          )}]`,
          type: 'info',
          actualNotification: actualNotification
        })
      }
    }
  }

  if (message.event_type === 'MULTIPLE_CLOSURE_COMPLETED') {
    notify({
      message: `${translate('Multiple closing executed successfully')}`,
      type: 'success',
    })
  }

  if (message.event_type === 'DISPATCH_TYPE_SUBTYPE_CHANGED') {
    if (verifyPermission(['dispatch_index'])) {
      notify({
        idMessage: message.content.dispatch_id,
        message: `${translate(
          'Type and/or Subtype changed in the dispatch'
        )} ID-[${message.content.code}]`,
        type: 'info',
        clickableMessage: {
          id: message.content.dispatch_id,
          action: () => syncDispatchFromId(message.content.dispatch_id),
          urlRedirection: '/dispatch',
          hideButton: false,
        },
        actualNotification: actualNotification
      })
    }
  }

  if (message.event_type === 'OCCURRENCE_TYPE_SUBTYPE_CHANGED') {
    const occurrenceID = message.content.occurrence_id
    syncOccurrenceEditAttendent(occurrenceID)
    const openOccurrence = (id) => {
      syncOccurrenceEditAttendent(id)
      windowManager().occurrence.open.set(true)
    }

    // if (message.content.occurrence_id !== occurrenceObject().id.get()) {

    notify({
      idMessage: message.content.occurrence_id,
      message: `${translate(
        'Type and/or Subtype changed in the occurrence'
      )} ID-[${message.content.occurrence_id}]`,
      type: 'info',
      clickableMessage: {
        id: message.content.occurrence_id,
        action: () => openOccurrence(message.content.occurrence_id),
        hideButton: false,
        urlRedirection: '/entry',
      },
      actualNotification: actualNotification

    })
    // }
  }

  if (
    message.event_type === 'OCCURRENCE_FEATURED' ||
    message.event_type === 'OCCURRENCE_UNFEATURED'
  ) {
    try {
      updateDispatchRowsTable({
        dispatchId: message.content.dispatch_id,
        featured: message.content.featured,
      })
    } catch (error) {
      console.error(error)
    }
  }

  if (message.event_type === 'DISPATCH_TYPE_SUBTYPE_CHANGED') {
    try {
      updateDispatchRowsTable({
        dispatchId: message.content.dispatch_id,
        type: `[${message.content.type.acronym}] ${message.content.type.name}`,
        subtype: message.content.subtype
          ? `[${message.content.subtype.acronym}] ${message.content.subtype.name}`
          : '-',
        priority: message.content.priority,
      })

    } catch (error) {
      console.error(error)
    }

    try {
      updateDeviceTypeAndSubtypeRowsTable({
        dispatchId: message.content.dispatch_id,
        type: `[${message.content.type.acronym}] ${message.content.type.name}`,
        subtype: message.content.subtype
          ? `[${message.content.subtype.acronym}] ${message.content.subtype.name}`
          : '-',
      })

    } catch (error) {
      console.error(error)
    }
  }


  if (message.event_type === 'OCCURRENCE_COMMENT_CHANGED') {
    const changedByUser = message.content.changed_by_user.id
    const openOccurrence = (id) => {
      syncOccurrenceEditAttendent(id)
      windowManager().occurrence.open.set(true)
    }

    if (Boolean(message.content.is_deleted) && changedByUser !== user) {
      notify({
        idMessage: message.content.dispatch_id,
        message: `${translate('Comment deleted on occurrence')} ID-[${message.content.occurrence_id
          }]`,
        type: 'info',
        clickableMessage: {
          id: message.content.occurrence_id,
          action: () => openOccurrence(message.content.occurrence_id),
          hideButton: false,
          urlRedirection: '/entry',
        },
        actualNotification: actualNotification

      })
    }

    if (
      Boolean(message.content.is_edited) &&
      Boolean(message.content.is_deleted) == false &&
      changedByUser !== user
    ) {
      notify({
        idMessage: message.content.dispatch_id,
        message: `${translate('Comment edited on occurrence')} ID-[${message.content.occurrence_id
          }]`,
        type: 'info',
        clickableMessage: {
          id: message.content.occurrence_id,
          action: () => openOccurrence(message.content.occurrence_id),
          hideButton: false,
          urlRedirection: '/entry',
        },
        actualNotification: actualNotification
      })
    }
  }

  if (message.event_type === 'DISPATCH_CLOSURE_REQUESTED') {
    updateOccurrenceRowsTable({
      occurrenceId: message.content.occurrence_id,
      closureRequested: message.content.occurrence.closure_requested,
    })
  }

  if (message.event_type === 'DISPATCH_DEVICE_REMOVAL_REQUESTED') {
    updateDeviceRowsTable({
      deviceId: message.content.device.id,
      closureRequestedDevice: message.content.removal_requested,
    })
    if (verifyPermission(['dispatch_index'])) {
      notify({
        idMessage: message.content.id,
        message: `${translate('Device removal requested for dispatch:')} ${message.content.code
          }`,
        type: 'warning',
        autoCloseDuration: 10000,
        clickableMessage: {
          id: message.content.id,
          action: () => syncDispatchFromId(message.content.id),
          urlRedirection: '/dispatch',
          hideButton: false,
        },
        actualNotification: actualNotification
      })
    }
  }


  if (message.event_type === 'OCCURRENCE_COMMENT_IMAGE_PATH') {
    editedComment({
      mediaPath: mountUrlRequest(
        `/occurrence-comment/get-media/${message.content.media_path}`
      ),
      id: message.content.id,
      fileType: message.content.file_type,
      fileName: message.content.file_name,
    })
  }

  if (message.event_type === 'DISPATCH_CLOSURE_REQUESTED') {
    if (verifyPermission(['dispatch_index'])) {
      notify({
        idMessage: message.content.id,
        message: `${translate('Requested closure for dispatch:')} ${message.content.code
          }`,
        type: 'warning',
        autoCloseDuration: 10000,
        clickableMessage: {
          id: message.content.id,
          action: () => syncDispatchFromId(message.content.id),
          urlRedirection: '/dispatch',
          hideButton: false,
        },
        actualNotification: actualNotification
      })
    }
  }

  if (message.event_type === 'DISPATCH_STILL_ON_HOLD') {
    notify({
      idMessage: message.content.dispatch,
      message: `${translate('Dispatch retained for', {
        timeHolded: elapsedTime(message.content.created_at)
      })} ${message.content.code}`,
      type: 'info',
      autoCloseDuration: 10000,
      clickableMessage: {
        id: message.content.dispatch,
        action: () =>
          syncDispatchFromId(message.content.dispatch),
        urlRedirection: '/dispatch',
        hideButton: false,
      },
      actualNotification: actualNotification
    })
  }

  if (message.event_type === 'OCCURRENCE_VEHICLE_PASSAGE') {
    if (verifyPermission(['dispatch_index'])) {
      const {
        id: dispatchId,
        code,
        latitude,
        longitude,
        plate,
        current_date: currentDate,
        occurrence_id: occurrenceId,
        vehicle_info: vehicleInfo,
        status_id: statusId
      } = message.content

      const { brand, circunstance, color, model, type } = vehicleInfo

      const setPosition = () => {
        forceViewMap().zoom.set(15);
        forceViewMap().position.set(new LatLng(latitude, longitude));
      }

      const existMarker = markersState()['vehiclePassage'][dispatchId].get()
      if (!existMarker) {

        markersState()['vehiclePassage'].merge({
          [dispatchId]: {
            id: dispatchId,
            markerId: `${'vehiclePassage'}-${dispatchId}`,
            position: new LatLng(latitude, longitude),
            identifier: dispatchId,
            status: statusId,
            code,
            plate,
            occurrenceId,
            currentDate,
            brand,
            circunstance,
            color,
            model,
            typeVehicle: type
          }
        });

        notify({
          idMessage: dispatchId,
          message: `${translate('There was passage of a vehicle registered in the Dispatch')} ID-[${code}]`,
          type: 'info',
          clickableMessage: {
            id: dispatchId,
            action: () => {
              syncDispatchFromId(message.content.id).finally(() => {
                setPosition()
                handleClearUniqueNotification()
                currentIdNotification().set(dispatchId)
              })
            },
            urlRedirection: '/dispatch',
            hideButton: false,
          },
          actualNotification: actualNotification
        })
      } else {
        updateMarker({
          markerType: 'vehiclePassage',
          markerIdentifier: dispatchId,
          attribute: 'position',
          value: new LatLng(latitude, longitude),
        })

        updateMarker({
          markerType: 'vehiclePassage',
          markerIdentifier: dispatchId,
          attribute: 'currentDate',
          value: currentDate,
        })

        updateMarker({
          markerType: 'vehiclePassage',
          markerIdentifier: dispatchId,
          attribute: 'status',
          value: statusId,
        })

        if (dispatchId == dispatchStateId.get()) {
          setPosition()
        }
      }
    }
  }
  if (message.event_type === 'INCIDENT_NEW_LOCATION') {
    try {
      const {
        incident_id: incidentId,
        dispatch,
        latitude,
        longitude,
        occurrence_id: occurrenceId,
        received_at: receivedAt
      } = message.content

      const existMarker = markersState()['locationRequester'][incidentId]?.get();
      const currentPosition = markersState()['locationRequester'][incidentId]['position']?.get();
      const isSamePosition = (currentPosition?.latitude === latitude && currentPosition?.longitude === longitude);

      const setPosition = () => {
        forceViewMap().zoom.set(15);
        forceViewMap().position.set(new LatLng(latitude, longitude));
      }
      
      dispatchOcurrence.incident.location.merge({
        latitude: latitude,
        longitude: longitude,
      })

      if (existMarker && !isSamePosition) {
        updateMarker({
          markerType: 'locationRequester',
          markerIdentifier: incidentId,
          attribute: 'position',
          value: new LatLng(latitude, longitude),
        })

        if (verifyPermission(['dispatch_index'])) {
          notify({
            idMessage: message.content.id,
            message: `${translate('New position from requester')} ${dispatch.code}`,
            type: 'info',
            autoCloseDuration: 10000,
            clickableMessage: {
              id: dispatch.id,
              action: () => {
                syncDispatchFromId(dispatch.id)
                setPosition()
              },
              urlRedirection: '/dispatch',
              hideButton: false,
            },
            actualNotification: actualNotification
          })
        }
      }

    } catch (error) {
      console.error(`${JSON.stringify(message)} - ${JSON.stringify(error)}`)
    }
  }
}